import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, Home, Bot, Check } from 'lucide-react';

const PRODUCT_MAP = {
  'tseg': {
    title: 'TSEG — Social Engineering Guard',
    icon: ShieldCheck,
    gradient: 'from-purple-500 to-pink-500',
    description: 'Advanced behavioral analysis and automated response engine to block social engineering attempts across your org.',
    bullets: [
      'Real-time detection and response',
      'Adaptive employee training workflows',
      'Integrations with Slack, Gmail, O365'
    ]
  },
  'nexus-pay': {
    title: 'Nexus Pay — Unified Payments',
    icon: Home,
    gradient: 'from-blue-500 to-cyan-500',
    description: 'Open Source and In Development',
    bullets: [
      'Coming Soon',
      'Open Source Project',
      'Currently Under Development'
    ]
  },
  'sentinel-ai': {
    title: 'Sentinel AI — Autonomous Security',
    icon: Bot,
    gradient: 'from-green-500 to-teal-500',
    description: 'Open Source and In Development',
    bullets: [
      'Coming Soon',
      'Open Source Project',
      'Currently Under Development'
    ]
  }
};

export default function ProductDetail() {
  const { slug } = useParams();
  const product = PRODUCT_MAP[slug] || PRODUCT_MAP['tseg'];
  const Icon = product.icon;

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-8">
        <Link to="/" className="inline-flex items-center text-gray-300 hover:text-white mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to home
        </Link>

        <div className="bg-gray-900/50 border border-gray-800 rounded-2xl px-10 pb-10 pt-10">
          <div className="flex items-center space-x-4 mb-6">
            <div className={`w-14 h-14 rounded-xl bg-gradient-to-r ${product.gradient} bg-opacity-10 border border-gray-700 flex items-center justify-center`}>
              <Icon className={`w-7 h-7 bg-gradient-to-r ${product.gradient} bg-clip-text text-transparent`} />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold">{product.title}</h1>
          </div>
          <p className="text-gray-300 leading-relaxed mb-8">{product.description}</p>

          <div className="space-y-3">
            {product.bullets.map((b) => (
              <div key={b} className="flex items-center space-x-3">
                <Check className="w-4 h-4 text-green-500" />
                <span className="text-gray-300">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}


